import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../../api/api";

const Arrow = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round" className="ml-1.5">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const PremiumButton = ({ text }) => (
  <span
    style={{ fontFamily: "'Inter', sans-serif" }}
    className="inline-flex items-center justify-center bg-[#FFEB3B] group-hover:bg-[#f5e132] text-black px-3.5 py-1.5 xs:px-4 sm:px-5 sm:py-2 rounded-[3px] text-[8.5px] xs:text-[9px] sm:text-[10px] font-bold tracking-[0.13em] uppercase transition-all duration-300 shadow group-hover:shadow-md"
  >
    {text} <Arrow />
  </span>
);

// 🛠️ PURI LINKS FRONTEND SE CONTROL KARNE KE LIYE FUNCTION
const getFrontendLink = (item, index, activeTab) => {
  const title = (item.title || "").toLowerCase();

  


  // 3️⃣ Agar title match na ho toh card ke index (position) ke hisaab se fix link de sakte hain:
  const fallbackRoutes = ["/photobook","/notebooks", "/dailyplanner",  "/gift-hampers","/bold-bright" ];
  return fallbackRoutes[index % fallbackRoutes.length];
};

const CommonCard = ({ item, isHero, isLargeGrid, index, activeTab }) => {
  // Frontend se link generate kar rahe hain
  const dynamicLink = getFrontendLink(item, index, activeTab);

  return (
    <Link
      to={dynamicLink}
      className={`relative rounded-[12px] xs:rounded-[14px] sm:rounded-[20px] overflow-hidden cursor-pointer group shadow-[0_4px_24px_rgba(0,0,0,0.10)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.18)] active:scale-[0.98] transition-all duration-300 hover:-translate-y-[4px] block 
      ${isHero ? "h-[230px] xs:h-[280px] sm:h-[360px] md:h-[480px]" : 
        isLargeGrid ? "h-[250px] xs:h-[350px] lg:h-full" : "h-[150px] xs:h-[190px] sm:h-[210px] md:h-[230px]"}`}
    >
      <img src={item.image_url} alt={item.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-full p-4 sm:p-8 z-10 flex flex-col justify-end">
        <h3 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: "italic" }} className="text-white text-[19px] xs:text-[24px] sm:text-3xl md:text-[40px] font-semibold leading-[1.1] mb-1 drop-shadow-sm">
          {item.title}
        </h3>
        <p style={{ fontFamily: "'Inter', sans-serif" }} className="text-white/85 text-[10.5px] sm:text-[12.5px] leading-relaxed mb-4 font-medium line-clamp-2">
          {item.description}
        </p>
        <div><PremiumButton text={item.cta || "View Collection"} /></div>
      </div>
    </Link>
  );
};

const PromotionalSection = () => {
  const [cards, setCards] = useState([]);
  const [activeTab, setActiveTab] = useState("bestSellers");

  useEffect(() => {
    apiFetch(`/home/promo.php?tab=${activeTab}`, { auth: false })
      .then((res) => setCards(res.data || []))
      .catch((err) => console.error("Error loading promo cards:", err));
  }, [activeTab]);

  if (cards.length === 0) return null;

  const heroCards = cards.slice(0, 2);
  const gridLarge = cards[2];
  const stackedCards = cards.slice(3, 5);

  return (
    <section className="py-8 sm:py-16 md:py-24 px-4 sm:px-12 bg-[#FAFAF8]">
      {/* Toggle Section */}
      <div className="flex justify-center mb-8">
        <div className="bg-gray-200 p-1 rounded-full flex gap-1">
          {["bestSellers", "newArrivals"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-6 py-2 rounded-full text-sm font-bold transition-all ${activeTab === tab ? "bg-black text-white" : "text-gray-600 hover:text-black"}`}
            >
              {tab === "bestSellers" ? "BEST SELLERS" : "NEW ARRIVALS"}
            </button>
          ))}
        </div>
      </div>

      <div className="text-center mb-10">
        <h2 style={{ fontFamily: "'Cormorant Garamond', serif" }} className="text-[#111] text-3xl sm:text-[54px] font-semibold italic leading-tight">
          Crafted for Every Moment
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
        {heroCards.map((item, index) => (
          <CommonCard key={item.id || index} item={item} isHero={true} index={index} activeTab={activeTab} />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.62fr] gap-5">
        {gridLarge && <CommonCard item={gridLarge} isHero={false} isLargeGrid={true} index={2} activeTab={activeTab} />}
        <div className="flex flex-col gap-5">
          {stackedCards.map((item, index) => (
            <CommonCard key={item.id || index} item={item} isHero={false} index={index + 3} activeTab={activeTab} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromotionalSection;